// src/utils/countryCode.js
// Mappe un nom de pays (français OU anglais) vers son code ISO-2 et, inversement,
// un nom de pays quelconque vers le nom français canonique de world-countries.
//
// Sert à l'autocomplete ville (<CityAutocomplete>) :
//  - countryNameToCode : biaiser la recherche /geocode au pays choisi (?countrycodes=xx)
//  - canonicalCountryName : quand on déduit le pays depuis une ville sélectionnée,
//    garantir que la valeur correspond EXACTEMENT à une option de <CountrySelect>
//    (même source world-countries) pour que le select l'affiche correctement.
//
// La normalisation est alignée sur backend/utils/normalizeText.js (normalizeCountryName)
// pour rester cohérent avec le matching du ciblage de feed.
import countries from 'world-countries'

const normalize = (s) =>
  (s || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '') // diacritiques
    .toLowerCase()
    .replace(/['’]/g, '') // apostrophes (d'Ivoire -> divoire)
    .replace(/-/g, ' ') // tirets -> espaces
    .replace(/\s+/g, ' ')
    .trim()

const nameToCode = {}
const codeToCanonical = {}

countries.forEach((c) => {
  const code = c.cca2
  const fra = c.translations?.fra?.common
  const eng = c.name?.common
  codeToCanonical[code] = fra || eng
  if (fra) nameToCode[normalize(fra)] = code
  if (eng) nameToCode[normalize(eng)] = code
})

// Renvoie le code ISO-2 (ex: "FR") d'un nom de pays, ou null si introuvable.
export function countryNameToCode(name) {
  if (!name) return null
  return nameToCode[normalize(name)] || null
}

// Renvoie le nom français canonique (= valeur attendue par <CountrySelect>)
// à partir d'un nom potentiellement issu d'une autre source (ex: Nominatim).
// Si le pays n'est pas reconnu, on renvoie le nom d'origine inchangé.
export function canonicalCountryName(name) {
  const code = countryNameToCode(name)
  return code ? codeToCanonical[code] : name || ''
}
